import {openDialog} from 'platform/components';

import {MagicPublishingMissingField} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {MagicPublishingForm} from '../components/MagicPublishingForm';

interface OpenMagicPublishingDialogProps extends RequiredTestIdProps {
  vehicleId: string;
  missingFields: MagicPublishingMissingField[];
  missingMandatoryFields: string[];
  hasSalesPhotos: boolean;
  onSuccess?: () => void;
  onRequestCreated?: (requestId: string) => void;
}

export function openMagicPublishingDialog(props: OpenMagicPublishingDialogProps) {
  openDialog(
    <MagicPublishingForm
      vehicleId={props.vehicleId}
      missingFields={props.missingFields}
      missingMandatoryFields={props.missingMandatoryFields}
      hasSalesPhotos={props.hasSalesPhotos}
      onSuccess={props.onSuccess}
      onRequestCreated={props.onRequestCreated}
      data-testid={props['data-testid']}
    />,
    {
      title: i18n.t('entity.vehicle.labels.magicPublishing'),
      'data-testid': props['data-testid'],
      scrollBehavior: 'outside',
    }
  );
}
